const Banners = (($) => {
  let _els = {};
  let currentIndex = 0;
  let totalItems;
  let direction = 'next';

  const init = () => {
    _els.banner = $('.banner--top');
    _els.navPrev = $('.banner--top .nav-btn--prev');
    _els.navNext = $('.banner--top .nav-btn--next');
    _els.messages = $('.banner--top .banner__message');
    _els.currentTxt = $('.banner--top .count__current');

    totalItems = _els.messages.length;

    _addListeners();
  };

  const _addListeners = () => {
    _els.navPrev.on('click', (e) => {
      currentIndex--;
      direction = 'prev';
      _incrementBanner();
    });

    _els.navNext.on('click', (e) => {
      currentIndex++;
      direction = 'next';
      _incrementBanner();
    });
  };

  const _incrementBanner = () => {
    if (currentIndex < 0) {
      currentIndex = totalItems - 1;
    } else if (currentIndex >= totalItems) {
      currentIndex = 0;
    }

    if (direction === 'prev') {
      _els.messages
        .removeClass('in in--left in--right out out--right out--left')
        .addClass('out out--right');
      _els.messages
        .eq(currentIndex)
        .removeClass('out out--right out--left')
        .addClass('in in--right');
    } else if (direction === 'next') {
      _els.messages
        .removeClass('in in--left in--right out out--right out--left')
        .addClass('out out--left');
      _els.messages
        .eq(currentIndex)
        .removeClass('out out--right out--left')
        .addClass('in in--left');
    }

    _els.currentTxt.text(currentIndex + 1);
    _els.navPrev.css({ 'pointer-events': 'none' });
    _els.navNext.css({ 'pointer-events': 'none' });

    setTimeout(() => {
      _els.messages.not(':eq(' + currentIndex + ')').hide();
      _els.messages.eq(currentIndex).show();
      _els.navPrev.css({ 'pointer-events': 'all' });
      _els.navNext.css({ 'pointer-events': 'all' });
    }, 350);
  };

  module.exports = {
    init: init,
  };
})(jQuery);
